import { render, staticRenderFns } from "./acmedonly.vue?vue&type=template&id=22681697&scoped=true&"
import script from "./acmedonly.vue?vue&type=script&lang=js&"
export * from "./acmedonly.vue?vue&type=script&lang=js&"
import style0 from "./acmedonly.vue?vue&type=style&index=0&id=22681697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22681697",
  null
  
)

export default component.exports